import React from 'react';
import Select from 'react-select';
import { Input } from 'reactstrap';

function TextInputType({ answers = [] }) {
  const answer = React.useMemo(() => {
    return answers.find(i => i.answer)
  }, [answers])
  return (
    <Input value={answer?.answer || ''} disabled />

  );
}

export default TextInputType;